import { useTranslation } from 'react-i18next';

import KitoContentSection from '../../../components/DataDisplay/ContentSection';
import KitoBuddy from '../../../components/Buddy';

export default function WhatSection({ answer, question }) {
  const { t } = useTranslation();
  const answerItems = Array.isArray(answer) ? answer : [answer];

  return (
    <>
      <KitoBuddy image="whatIs">{t(question)}</KitoBuddy>
      <KitoContentSection variant="orange-definition">
        {answerItems.filter(Boolean).map((answerText, index) => (
          <p key={answerText || index}>{t(answerText)}</p>
        ))}
      </KitoContentSection>
    </>
  );
}
